module.exports = __webpack_public_path__ + "static/media/Jntuk-logo.e301ab1a.png";